export const Modals = [];



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/modals.ts